import styled from 'styled-components';

export const LocalCameraWrap = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: inherit;
  overflow: hidden;
`;
